export default __webpack_public_path__ + "static/media/struct5.e3459781.png";